import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OccEndpointsService } from "@spartacus/core";
import { Observable } from "rxjs";
import { TiresWarrantyRequest } from "../../../model/tires-warranty.model";
import { TiresWarrantyAdapter } from "../tires-warranty.adapter";

@Injectable({
  providedIn: 'root'
})
export class OccTiresWarrantyAdapter implements TiresWarrantyAdapter {

  constructor (
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  startTiresWarranty(request: TiresWarrantyRequest): Observable<void> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    const url = this.occEndpoints.buildUrl('startTiresWarranty', {
      urlParams: { userId: 'current' }
    });
    return this.http.post<void>(url, request, { headers });
  }
}
